import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { resolvePieceLink, type PieceLinkTarget } from "../../../components/catalogue/catalogueResellerApi";
import { withFocusPiece } from "./publicCatalogueHelpers";
import "./resellerSharing.css";

/** Where a resolved short link opens: the studio's own preview, or the piece on the share link. */
export function pieceLinkDestination(target: PieceLinkTarget): string | null {
  const params = new URLSearchParams();
  params.set("catalogueId", target.catalogueId);
  const pieceId = target.studio ? target.productUniqueId : target.pieceId;
  if (!pieceId) return null;
  if (!target.studio) {
    if (!target.link) return null;
    params.set("link", target.link);
  }
  return `/catalogue-product-info/${encodeURIComponent(pieceId)}?${withFocusPiece(params, pieceId).toString()}`;
}

/**
 * /w/<code> (when the site has no preview proxy) and /open-piece/<code>: a short link from an
 * "Ask on WhatsApp" message. Studio staff signed in here land on the piece; anyone else goes
 * through the share link's usual gate.
 */
const OpenPieceLink: React.FC = () => {
  const { code } = useParams<{ code: string }>();
  const history = useHistory();
  const [problem, setProblem] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    resolvePieceLink(code)
      .then((env) => {
        if (cancelled) return;
        const to = env.success && env.data ? pieceLinkDestination(env.data) : null;
        if (to) {
          history.replace(to);
          return;
        }
        setProblem(
          env.status === 410
            ? "This link has ended. Ask the person who shared it for a new one."
            : "This link is not valid."
        );
      })
      .catch(() => {
        if (!cancelled) setProblem("Could not open this link. Check your connection and try again.");
      });
    return () => {
      cancelled = true;
    };
  }, [code, history]);

  return (
    <main className="hkp-open-piece" aria-live="polite">
      <p>{problem || "Opening the piece…"}</p>
    </main>
  );
};

export default OpenPieceLink;
